/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-10-19 15:42:51
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */
import { get, post } from 'src/api/http';
import * as types from './type';
import {TaskMess, SearchSelectParams, SearchSelectRows, ReturnPageData} from 'src/api/types.d';
class FirmwareUpgrade {
    getProgramList (programName:string, fileType:string): Promise<types.ProgramsData> {
        return get('/amr/remote-upgrade/programs', {
            fileType,
            programName,
            page: 1,
            rows: 1000,
        });
    }
    getDeviceType (type:string): Promise<types.DeviceTypeData[]> {
        return get('/amr/remote-upgrade/device-types', {fileType: type});
    }
    getSetting ():Promise<string[]> {
        return get('/amr/remote-upgrade/get-setting');
    }
    getDevicepgradeInfo (data: types.UpgradeInfoParams): Promise<types.UpgradeInfoData> {
        return post('/amr/remote-upgrade/device-upgrade-Info', {
            cstid: '',
            node: '',
            ...data,
        });
    }
    getAreaList (data:SearchSelectParams):Promise<ReturnPageData<SearchSelectRows>> {
        return get('/amr/remote-upgrade/areas', data);
    }
    delFileImpl (data: types.DeleteFilesParams): Promise<TaskMess> {
        return post('/amr/remote-upgrade/del-program', data);
    }
    getGroupList (data: types.GroupListParams): Promise<types.GroupListData> {
        return get('/amr/remote-upgrade/groups', data);
    }
    getTaskListAndStatusCount (data: types.TaskListParams): Promise<types.TaskData<types.TaskList>> {
        return get('/amr/remote-upgrade/tasks-statistics', data);
    }
    queryUpgradeTask (data: types.QueryUpgradeTaskParams): Promise<types.TaskData<types.TaskList>> {
        return get('/amr/remote-upgrade/upgrade-task-list', data);
    }
    queryUpgradeTaskStatictis (data: types.QueryUpgradeTaskParams): Promise<any> {
        return get('/amr/remote-upgrade/upgrade-task-statistics', data);
    }
    uploadFileImpl (data: types.UploadFileParams):Promise<TaskMess> {
        return post('/amr/remote-upgrade/save-program', data);
    }
    upgradeFileToDcuNew (data: types.UpgradeDcuNewParams): Promise<types.UpgradeDcuNewData> {
        return post('/amr/remote-upgrade/upgrade-file-dcu-new', {
            cstid: '',
            fieldValue: '',
            node: '',
            searchField: '',
            sortName: '',
            sortOrder: '',
            strlist: '',
            ...data,
        });
    }
    upgradeResend (data: types.UpgradeResendParams): Promise<TaskMess> {
        return post('/amr/remote-upgrade/resend', data);
    }
    upgradeReset (data: types.UpgradeResendParams): Promise<TaskMess> {
        return post('/amr/remote-upgrade/reset', data);
    }
    tryFTPConn (data: types.FTPConnParams): Promise<TaskMess> {
        return get('/amr/remote-upgrade/ftp-connect', data);
    }
}

export default new FirmwareUpgrade();
